module.exports = __webpack_public_path__ + "media/assets/images/nosco_landing/interattivo-00653df914dd26510191fc753ab9e706.svg";